import { DataTable, Table } from "capitalroadkit";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import PaymentsTableActions from "./PaymentsTableActions";

import { parseEnum, toCurrency, toDateString } from "../../../../resources/formatters/Formatter";

const PaymentsTable = ({ data, hiddenColumns, refreshData }) => {
  const columns = useMemo(
    () => [
      {
        id: "PayeeTable",
        columns: [
          {
            accessor: "clientLedger.name",
            Header: "Ledger",
            Cell: ({ cell: { value }, row: { original } }) => (
              <Link
                to={"/mse-cash-active/transactions"}
                state={{
                  uuid: original.clientLedger.uuid,
                  subType: original.clientLedger.ledgerType,
                  group: original.clientLedger.group,
                }}
              >
                {value}
              </Link>
            ),
          },
          {
            accessor: "payee",
            Header: "Payee",
          },
          {
            accessor: "bankBsbNumber",
            Header: "BSB number",
          },
          {
            accessor: "bankAccountNumber",
            Header: "Account number",
          },
          {
            accessor: "dateReceived",
            Header: "Date received",
            Cell: ({ cell: { value } }) => toDateString(value),
          },
          {
            accessor: "dateProcessed",
            Header: "Date processed",
            Cell: ({ cell: { value } }) => toDateString(value),
          },
          {
            accessor: "amount",
            rightAlign: true,
            Header: "Amount",
            Cell: ({ cell: { value } }) => toCurrency(value),
          },
          {
            accessor: "narration",
            Header: "Narration",
          },
          {
            accessor: "status",
            Header: "Status",
            Cell: ({ cell: { value } }) => parseEnum(value),
          },
          {
            id: "actions",
            Cell: ({ row: { original } }) => <PaymentsTableActions payment={original} refreshData={refreshData} />,
          },
        ],
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={data}
      hiddenColumns={hiddenColumns}
      sortBy={[
        {
          id: "dateReceived",
          desc: true,
        },
      ]}
    />
  );
};

export default PaymentsTable;
